import { render, staticRenderFns } from "./rewardOnePlusSixCollectEdit.vue?vue&type=template&id=d53c207c&scoped=true&"
import script from "./rewardOnePlusSixCollectEdit.vue?vue&type=script&lang=js&"
export * from "./rewardOnePlusSixCollectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53c207c",
  null
  
)

export default component.exports